import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import UserService from "apiService/permissions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useUpdateUser = (setShowEditForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.UPDATE_USER],
    (data) => UserService.updateUser(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_USER_LIST);
        setShowEditForm(false)
        toast.success('User updated successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useUpdateUser